import React from 'react'
import classes from "./StatNavBar.module.css"
import {
  WalletModalProvider,
  WalletMultiButton,
} from "@solana/wallet-adapter-react-ui";

const StatNavBar = () => {
  return (
      
    <WalletModalProvider>
      <div className={classes["stat-nav-bg"]}>
        <div id={classes["stat-nav-btn"]}>
          <WalletMultiButton />
        </div>
      </div>
    </WalletModalProvider>
  )
}

export default StatNavBar